// THIS FILE IS AUTO-GENERATED. DO NOT EDIT. Re-run --exportTsApi to regenerate.
import { ChirpConfig, IChirpConfig } from "./ChirpConfig.gen";
import { TrackerConfig, ITrackerConfig } from "./TrackerConfig.gen";
import { RadarClassificationMode } from "./Shared.RadarClassificationMode.gen";
import { SensorConfigType } from "./Shared.SensorConfigType.gen";

export interface IRadarConfiguration {
	transmitterEnabled: boolean;

	secondsToTransmitPerMinute: number;

	minimumSecondsToTransmit: number;

	calibrationConfig: string | undefined;

	chirpConfig: string | undefined;

	chirpConfigId: string | undefined;

	chirpConfigPreset: IChirpConfig | undefined;

	radarTrackerConfigId: string | undefined;

	radarTrackerConfigPreset: ITrackerConfig | undefined;

	radarTrackerConfig: string | undefined;

	videoTrackerConfigId: string | undefined;

	videoTrackerConfigPreset: ITrackerConfig | undefined;

	videoTrackerConfig: string | undefined;

	freezeDetectionProfileLearning: boolean;

	radarClassificationMode: RadarClassificationMode;

	learnedDetectionProfiles: string | undefined;

	id: string | undefined;

	deviceId: string | undefined;

	configType: SensorConfigType;

	$type?: string | undefined;
}
export class RadarConfiguration {
	constructor(data?: IRadarConfiguration) {
		if (!data) return;
		if (data.$type && data.$type !== this.$type) console.warn('The $type of data being parsed does not match the type of the object being created (' + this.$type + ')');
		Object.assign(this, data);
		if (data.chirpConfigPreset) { this.chirpConfigPreset = new ChirpConfig(data.chirpConfigPreset); }
		if (data.radarTrackerConfigPreset) { this.radarTrackerConfigPreset = new TrackerConfig(data.radarTrackerConfigPreset); }
		if (data.videoTrackerConfigPreset) { this.videoTrackerConfigPreset = new TrackerConfig(data.videoTrackerConfigPreset); }
	}

	transmitterEnabled: boolean = false;

	secondsToTransmitPerMinute: number = 0;

	minimumSecondsToTransmit: number = 0;

	calibrationConfig: string | undefined;

	chirpConfig: string | undefined;

	chirpConfigId: string | undefined;

	chirpConfigPreset: ChirpConfig | undefined;

	radarTrackerConfigId: string | undefined;

	radarTrackerConfigPreset: TrackerConfig | undefined;

	radarTrackerConfig: string | undefined;

	videoTrackerConfigId: string | undefined;

	videoTrackerConfigPreset: TrackerConfig | undefined;

	videoTrackerConfig: string | undefined;

	freezeDetectionProfileLearning: boolean = false;

	radarClassificationMode: RadarClassificationMode = 0;

	learnedDetectionProfiles: string | undefined;

	id: string | undefined;

	deviceId: string | undefined;

	configType: SensorConfigType = 0;

	static $type: string = "CoreApi.Models.RadarConfiguration, ";
	$type?: string | undefined = RadarConfiguration.$type;
}

